import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
export class Loadable extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "isUnmounted", void 0);
    this.state = {
      isReady: false
    };
    this.isUnmounted = false;
  }
  componentWillUnmount() {
    this.isUnmounted = true;
  }
  async componentDidMount() {
    await this.props.loader();
    if (this.isUnmounted) {
      return;
    }
    this.setState({
      isReady: true
    }, () => {
      const {
        onDataLoaded
      } = this.props;
      if (onDataLoaded) {
        onDataLoaded();
      }
    });
  }
  render() {
    const {
      children,
      loading
    } = this.props;
    if (this.state.isReady) {
      return children;
    }
    return loading ? /*#__PURE__*/React.createElement(loading) : null;
  }
}
//# sourceMappingURL=loadable.js.map